import { z } from 'zod';

const slugRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const seniorityLevels = [
  'exec',
  'lead',
  'senior',
  'mid',
  'junior',
  'intern',
] as const;

export const positionFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, 'Mínimo 2 caracteres')
    .max(80, 'Máximo 80 caracteres'),
  short_name: z
    .string()
    .trim()
    .max(20, 'Máximo 20 caracteres')
    .optional()
    .or(z.literal('')),
  slug: z
    .string()
    .trim()
    .min(2, 'Mínimo 2 caracteres')
    .max(60, 'Máximo 60 caracteres')
    .regex(slugRegex, 'Solo minúsculas, números y guiones (ej: dev-lead)'),
  description: z
    .string()
    .trim()
    .max(280)
    .optional()
    .or(z.literal('')),
  seniority: z.enum(seniorityLevels),
  is_active: z.boolean(),
  sort_order: z.number().int().min(0),
});

export type PositionFormValues = z.infer<typeof positionFormSchema>;

export const seniorityLabels: Record<(typeof seniorityLevels)[number], string> = {
  exec: 'Ejecutivo',
  lead: 'Líder',
  senior: 'Senior',
  mid: 'Semi senior',
  junior: 'Junior',
  intern: 'Pasante',
};
